export default __webpack_public_path__ + "static/Waterfall_Andreatta_Waterscapes_Grants_Pass_Oregon-01051580d6503300ff9dafec35f04f26.jpg";